exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e46dbdd6] .el-card__body{height:100%}", ""]);

// exports
